<ion-header class="ion-no-border" [ngClass]="{'map': map, 'normal': !map, 'alt-header-bg': alt && !isWeb}">
  <ion-toolbar mode="md" [class]="alt && !isWeb ? 'alt-header' : ''">
    <div class="flex items-end px-4 pb-3 h-[60px]" [class]="!back && !isWeb ? 'justify-center' : 'justify-start'">
      <div class="flex items-center">
        <ion-button mode="ios" fill="clear" (click)="goBack()" *ngIf="back" size="small" class="h-fit">
          <ion-icon slot="icon-only" class="text-lg" src="../../../../assets/svg/arrowLeft.svg" />
        </ion-button>
        <ion-label class="text-sm sm:text-sm md:text-base lg:text-lg xl:text-xl font-medium whitespace-nowrap overflow-hidden text-ellipsis max-w-full" [class]="!back ? 'ml-0 pt-4' : 'ml-2'" color="secondary">
          <!-- Prefer titleKey (translated) when provided, fallback to raw title -->
          <ng-container *ngIf="titleKey && titleKey.length; else rawTitle">{{ titleKey | translate }}</ng-container>
          <ng-template #rawTitle>{{ title }}</ng-template>
        </ion-label>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
